export const HOST = import.meta.env.VITE_HOST_API;
export const VERSION = 'api/v1/';
export const IP_ORIGEN_URL = 'https://api.ipify.org/?format=json';

const APP_URL = {
    GUARDARFORMWEB: `${HOST}${VERSION}app/request/sendInfoOlan`,
    GUARDARCRMFORMWEB: `${HOST}${VERSION}web/contrato/crearLeadInstitucion`,
    REGISTRARORIGENLEAD: `${HOST}${VERSION}web/contrato/registrarOrigenLead`,
}

export default APP_URL
